export default "__VITE_ASSET__14f06a45__"